import React from 'react';
import { Navbar } from '../components/Navbar';
import { PricingSection } from '../components/AcquireFlowPricing';
import { Footer } from '../components/AcquireFooter';
import { SEOHead } from '../components/SEO/SEOHead';
import { pricingPlans } from '../data/pricingPlans';
export function PricingPage() {
  return <>
      <SEOHead title="Pricing & Plans - AcquireFlow" description="Choose the perfect AcquireFlow plan for your real estate investment business. Professional and Enterprise plans available with flexible monthly or yearly billing." canonical="https://acquireflow.com/pricing" data-id="element-2706" />

      <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707]" data-id="element-2707">
        <Navbar data-id="element-2708" />

        <main className="flex-grow" data-id="element-2709">
          {/* Hero Section */}
          <section className="relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] py-20 px-6" data-id="element-2710">
            <div className="max-w-4xl mx-auto text-center" data-id="element-2711">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm mb-6" data-id="element-2712">
                <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-2713" />
                <p className="text-sm md:text-base font-medium text-[#3ab795] tracking-wide uppercase" data-id="element-2714">
                  Simple Pricing
                </p>
              </div>

              <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-2715">
                Invest in Your{' '}
                <span className="text-[#3ab795] relative inline-block" data-id="element-2716">
                  Deal Flow
                  <span className="absolute -bottom-2 left-0 right-0 h-1 bg-[#3ab795]/30 rounded-full" data-id="element-2717"></span>
                </span>
              </h1>

              <p className="text-xl md:text-2xl text-[#b8bcc8] leading-relaxed font-light max-w-3xl mx-auto" data-id="element-2718">
                One closed deal pays for a year of AcquireFlow. Most investors
                close their first deal within 60 days.
              </p>
            </div>
          </section>

          {/* Pricing Section */}
          <section className="relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] overflow-hidden" data-id="element-2719">
            <PricingSection title="Choose Your Plan" subtitle="Flexible Options for Every Investor" description="Start with a 10-day free trial. No credit card required. Cancel anytime." plans={pricingPlans} data-id="element-2720" />
          </section>

          {/* FAQ Highlight */}
          <section className="relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] py-20 px-6" data-id="element-2721">
            <div className="max-w-4xl mx-auto text-center" data-id="element-2722">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-2723">
                Have Questions?
              </h2>
              <p className="text-lg text-[#b8bcc8] mb-8" data-id="element-2724">
                Check out our FAQ section or contact our team for personalized
                assistance.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2725">
                <a href="/#faq" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 border border-white/20 rounded-xl text-white font-medium hover:bg-white/20 transition-all duration-300" data-id="element-2726">
                  View FAQ
                </a>
                <a href="/contact" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#3ab795] rounded-xl text-white font-medium hover:bg-[#2da07d] transition-all duration-300" data-id="element-2727">
                  Contact Sales
                </a>
              </div>
            </div>
          </section>
        </main>

        <Footer data-id="element-2728" />
      </div>
    </>;
}